<template>
  <div>
    <app-breadcrumb>
      <template #contentright>
        <span />
      </template>
    </app-breadcrumb>
    <b-overlay :show="loading" spinner-variant="primary" spinner-type="grow" spinner-small rounded="sm">
      <div v-if="access_editing != ''" class="card">
        <div class="card-body">
          <p class="text-center text-danger mb-0"> {{ access_editing }} </p>
        </div>
      </div>
      <validation-observer v-if="access_editing == ''" ref="articleForm">
        <b-form class="articleForm" @submit.prevent="" @reset.prevent="resetForm">
          <div class="d-flex  flex-column divArea">
            <div class="frmContent">
              <div class="divContent">
                <div class="card">
                  <div class="card-body p-1">
                    <b-row>
                      <b-col cols="12">
                        <validation-provider #default="validationContext" vid="title" name="Tiêu đề"
                          rules="required|max:255">
                          <b-form-group>
                            <template #label>
                              <div class="d-flex flex-row justify-content-between">
                                <label class="d-block font-weight-bolder  ">Tiêu đề <span
                                    class="text-danger">*</span></label>
                                <b-form-checkbox v-model="frmData.hot" value="1" class="checkboxLabel"> Tin nóng
                                </b-form-checkbox>
                              </div>
                            </template>
                            <b-form-input id="title" ref="title" v-model="frmData.title"
                              :state="getValidationState(validationContext)" placeholder="Tiêu đề bài viết" />
                            <b-form-invalid-feedback> {{ validationContext.errors[0] }} </b-form-invalid-feedback>
                          </b-form-group>
                        </validation-provider>
                      </b-col>
                    </b-row>
                    <b-row>
                      <b-col cols="12" md="4">
                        <validation-provider #default="validationContext" name="Chuyên mục" rules="required">
                          <b-form-group>
                            <template #label>
                              <label class="d-block font-weight-bolder">Chuyên mục <span
                                  class="text-danger">*</span></label>
                            </template>
                            <v-select ref="category_id" v-model="frmData.category_id"
                              :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'" :options="all_cats"
                              :reduce="(val) => val.code" :state="getValidationState(validationContext)"
                              placeholder="--Chọn--" />
                            <b-form-invalid-feedback :state="getValidationState(validationContext)"> {{
                              validationContext.errors[0] }} </b-form-invalid-feedback>
                          </b-form-group>
                        </validation-provider>
                      </b-col>
                      <b-col cols="12" md="4">
                        <b-form-group>
                          <template #label>
                            <label class="d-block font-weight-bolder">Đăng thêm vào mục </label>
                          </template>
                          <v-select v-model="frmData.main_cats" multiple class="maincats" :options="data_cats"
                            :reduce="(val) => val.code" placeholder="--Chọn--" />
                        </b-form-group>
                      </b-col>
                      <b-col cols="12" md="4">
                        <validation-provider #default="validationContext" name="Thể loại" rules="required">
                          <b-form-group>
                            <template #label>
                              <label class="d-block font-weight-bolder">Thể loại <span
                                  class="text-danger">*</span></label>
                            </template>
                            <v-select ref="article_type_id" v-model="frmData.article_type_id"
                              :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'" :options="dataArticleType" label="name"
                              :reduce="(val) => val.id" :state="getValidationState(validationContext)"
                              placeholder="--Chọn--" />
                            <b-form-invalid-feedback :state="getValidationState(validationContext)"> {{
                              validationContext.errors[0] }} </b-form-invalid-feedback>
                          </b-form-group>
                        </validation-provider>
                      </b-col>
                    </b-row>
                    <b-row>
                      <b-col cols="12" md="4">
                        <b-form-group label="Nhờ xử lý" label-for="v-handler">
                          <v-select ref="department_id" v-model="frmData.department_id" :options="dataDepartment"
                            :disabled="show_nhoxuly" label="name" :reduce="val => val.id" placeholder="--Chọn--" />
                        </b-form-group>
                      </b-col>
                      <b-col cols="12" md="4">
                        <b-form-group label="Đồng tác giả" class="author" label-for="author">
                          <v-select v-model="frmData.author" multiple label="author" :filterable="false"
                            :options="dataAuthor" :reduce="val => val.id" @search="onSearch">
                            <template slot="no-options"> Nhập tên tài khoản </template>
                            <template slot="option" slot-scope="option">
                              <div class="d-center"> {{ option.full_name_alias }} </div>
                            </template>
                            <template slot="selected-option" slot-scope="option">
                              <div class="selected d-center"> {{ option.full_name_alias }} </div>
                            </template>
                          </v-select>
                        </b-form-group>
                      </b-col>
                      <b-col cols="12" md="4">
                        <b-form-group v-slot="{ ariaDescribedby }" label="Loại tin bài" class="content_type mb-0">
                          <b-form-checkbox v-for="option in dataContentType" :key="option.value"
                            v-model="frmData.content_type" :value="option.value" :aria-describedby="ariaDescribedby"
                            name="flavour-4a" inline>
                            <span :class="option.icon" />
                          </b-form-checkbox>
                        </b-form-group>
                      </b-col>
                    </b-row>
                    <b-row>
                      <b-col cols="12" md="4">
                        <b-form-group>
                          <template #label>
                            <label class="d-block font-weight-bolder">Loại hình xuất bản </label>
                          </template>
                          <v-select v-model="frmData.category_type_id" multiple class="maincats" label="title"
                            :options="dataCategoryType" :reduce="(val) => val.id" placeholder="--Chọn--" />
                        </b-form-group>
                      </b-col>
                      <b-col cols="12" md="4">
                        <b-form-group class="pt10">
                          <template #label>
                            <label class="d-block font-weight-bolder">&nbsp;</label>
                          </template>
                          <b-form-checkbox v-model="frmData.internal" value="1"> Tin nội bộ </b-form-checkbox>
                        </b-form-group>
                      </b-col>
                    </b-row>
                    <b-row>
                      <b-col cols="12">
                        <validation-provider #default="validationContext" name="Nội dung" rules="required">
                          <b-form-group>
                            <template #label>
                              <label class="d-block font-weight-bolder">Nội dung <span
                                  class="text-danger">*</span></label>
                            </template>
                            <editor ref="tinymce" v-model="frmData.content" :init="tinyOptions"
                              :state="getValidationState(validationContext)" tinymce-script-src="" />
                            <b-form-invalid-feedback :state="getValidationState(validationContext)"> {{
                              validationContext.errors[0] }} </b-form-invalid-feedback>
                          </b-form-group>
                        </validation-provider>
                      </b-col>
                      <b-col cols="12">
                        <b-form-group label="Tag" label-for="v-handler">
                          <voerro-tags-input v-model="tags" element-id="tags" :existing-tags="tags"
                            :allow-duplicates="false" :typeahead-url="api_tags" text-field="name"
                            placeholder="Nhập các thẻ mới được phân tách và bấm enter" id-field="id" :typeahead="true" />
                        </b-form-group>
                      </b-col>
                      <b-col cols="12">
                        <b-form-group>
                          <!-- ATTACH ORIGINAL FILE -->
                          <article-original-file :attached-files="frmData.attached_files"
                            @update-attached-files="onUpdateAttachedFiles" />
                        </b-form-group>
                      </b-col>
                      <b-col cols="12">
                        <b-form-group>
                          <label for="textarea-default">Tin bài liên quan <b-badge v-b-modal.showRelate
                              class="relate_id ml-1" variant="blue">Thêm bài viết liên quan</b-badge></label>
                          <ul id="relate_news" class="control-multiple-checkbox list_relate_news mt-1">
                            <draggable v-model="frmData.relate_data" draggable=".item" group="people"
                              @start="dragging = true" @end="dragging = false">
                              <li v-for="(item, index) in frmData.relate_data" :key="index" class="item">
                                <a href="javascript:void(0)">{{ item.title }} </a>
                                <span class="icon_delete btn-delete" @click="handlRemoveRelate(item)" />
                              </li>
                            </draggable>
                          </ul>
                        </b-form-group>
                      </b-col>
                      <b-col cols="12">
                        <b-form-group label="Ghi chú">
                          <b-form-input v-model="frmData.note" placeholder="Ghi chú" />
                        </b-form-group>
                      </b-col>
                    </b-row>
                  </div>
                </div>
              </div>
              <!-- SIDEBAR -->
              <article-sidebar-right ref="refArticleSidebarRight" :frm-data="frmData" :top-class="topClass"
                :class="allow_show_published ? 'show-publish' : ''" @update-dalet="logDalet"
                @update-content-editor="UpdateContentEditor" @preview="onPreviewFile"
                @delete-file-content="onDeleteFileContent" @update-content-files="onUpdateContentFile"
                @show-transcribe-modal="showTranscribeModal" @hide-transcribe-modal="hideTranscribeModal">
                <div v-if="allow_show_published" class="form-publish p-1">
                  <b-form-group>
                    <b-form-checkbox v-model="frmData.is_timer" class="checkboxLabel" value="1"> Hẹn giờ xuất bản
                    </b-form-checkbox>
                  </b-form-group>
                  <b-form-group>
                    <flat-pickr v-model="frmData.published_at" class="form-control" :disabled="!frmData.is_timer"
                      :config="config_date" placeholder="hh:mm, dd-mm-yyyy" />
                  </b-form-group>
                </div>
              </article-sidebar-right>
            </div>
            <!-- WORKFLOW BUTTONS -->
            <div v-if="workflowTransition.length > 0" class="cardsticky" :class="opacity">
              <div class="divSave">
                <div class="btnLeft">
                  <b-button type="button" class="mr-1 text-uppercase" variant="exit"
                    @click="onExit(frmData.id, frmData.status, frmData.created_by)">Thoát</b-button>
                  <b-button v-if="frmData.status != 5" type="button" class="mr-1" variant="trash"
                    @click="onDestroy(frmData.id, frmData.status)">Xóa</b-button>
                  <b-button type="submit" variant="save" class="mr-1" @click="validationForm(frmData.status)">Lưu
                  </b-button>
                </div>
                <div class="btnRight">
                  <b-button variant="eye" class="mr-1" @click="onPreview(frmData.id)">
                    <span class="align-middle">Xem trước</span>
                  </b-button>
                  <b-button v-for="(item, index) in workflowTransition" :key="index" type="button" :variant="item.style"
                    class="mr-1 font-weight-bolder" @click="validationForm(item.target_state)">
                    <template v-if="!item.hide"> {{ item.desc }} </template>
                  </b-button>
                </div>
              </div>
            </div>
          </div>
        </b-form>
      </validation-observer>
      <!-- MODAL RELATES -->
      <b-modal id="showRelate" body-class="p-0 mb-2" size="lg" cancel-variant="outline-secondary" no-close-on-backdrop
        hide-footer title="Danh sách bài viết">
        <dialog-relate :relate_ids="frmData.relate_data" @updateRelate="handleRelate" />
      </b-modal>
      <!-- MODAL SHOW PREVIEW -->
      <b-modal id="showPreview" size="lg" cancel-variant="outline-secondary" no-close-on-backdrop hide-footer
        title="Xem thử bài viết">
        <article-preview :article_id="frmData.id" />
      </b-modal>
      <!-- MODAL TRANSCRIBE SPEECH TO TEXT -->
      <b-modal id="fileTranscribeModal" ref="refFileTranscribeModal" body-class="p-0" size="xlg"
        cancel-variant="outline-secondary" no-close-on-backdrop hide-footer centered modal-class="no-header"
        ignore-enforce-focus-selector=".tox-tinymce-aux, .moxman-window, .tam-assetmanager-root" @shown="focusAudioPlayer"
        @hide="closeSocketSpeech">
        <template #modal-header="{ close }">
          <button type="button" aria-label="Close" class="close ml-auto px-1" @click="close"> × </button>
        </template>
        <FileTranscribeText ref="refFileTranscribeText" :file-data="fileData"
          :is-disconnect-socket="isDisconnectSocketSpeech" @hide-transcribe-modal="hideTranscribeModal"
          @update-transcribe-status="updateTranscribeStatus" @update-speech-to-text="handleSpeechToText"
          @update-icon="updateIcon" />
      </b-modal>
      <!-- MODAL FILE PREVIEW -->
      <b-modal id="filePreview" body-class="p-0 mb-2" size="lg" cancel-variant="outline-secondary" no-close-on-backdrop
        hide-footer title="">
        <file-preview :data-image="dataImage" />
      </b-modal>
      <!-- MODAL FILE MANAGER -->
      <b-modal id="modal-file-manager" v-model="showFileManagerModal" :title="fileManagerTitle" size="xl" :ok-only="true"
        ok-title="Đóng" hide-footer scrollable>
        <file-manager :in-editor="true" />
      </b-modal>
    </b-overlay>
  </div>
</template>

<script>
import Editor from '@tinymce/tinymce-vue'
import draggable from 'vuedraggable'
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import _ from 'lodash';
import {
  BButton, BRow, BCol, BForm, BFormInput, BFormInvalidFeedback, BFormCheckbox, BFormGroup, BBadge, BOverlay,
} from 'bootstrap-vue'
import Vue from 'vue';
import {
  ref, reactive, computed, toRefs, watch,
} from '@vue/composition-api'
import vSelect from 'vue-select'
import flatPickr from 'vue-flatpickr-component'
import { Vietnamese } from 'flatpickr/dist/l10n/vn'
import VoerroTagsInput from '@voerro/vue-tagsinput';
import {
  required, email, alphaNum, min, max,
} from '@validations'
import formValidation from '@core/comp-functions/forms/form-validation'
import store from '@/store'
import AppBreadcrumb from '@core/layouts/components/AppBreadcrumb.vue'
import { dynamicImageSettingSrcByDomain, showToast, useRouter } from '@core/utils/utils';
import axios from '@axios';
import { getToken } from '@/auth/utils'
import useJwt from '@/auth/jwt/useJwt';
import {
  defaultOptions, apiUpload, apiDownload, insertFileToEditor,
} from '@/libs/initTinymce'
import DialogRelate from './DialogRelate.vue';
import ArticlePreview from './ArticlePreview.vue'
import filePreview from './FilePreview.vue'
import FileManager from '../files/FileManager.vue';
import ArticleSidebarRight from './components/ArticleSidebarRight.vue'
import ArticleOriginalFile from './components/ArticleOriginalFile.vue'
import FileTranscribeText from './components/FileTranscribeText.vue'
import '@voerro/vue-tagsinput/dist/style.css'
import useArticle from './useArticle';
import { io } from 'socket.io-client';

export default {
  components: {
    ArticleSidebarRight,
    ArticleOriginalFile,
    FileTranscribeText,
    BCol,
    BRow,
    BButton,
    BFormGroup,
    BForm,
    BFormInput,
    BFormCheckbox,
    BFormInvalidFeedback,
    ValidationProvider,
    ValidationObserver,
    AppBreadcrumb,
    Editor,
    vSelect,
    draggable,
    BBadge,
    DialogRelate,
    ArticlePreview,
    BOverlay,
    filePreview,
    flatPickr,
    FileManager,
    VoerroTagsInput,
  },
  data() {
    return {
      required,
      email,
      alphaNum,
      min,
      max,
      topClass: '',
      dataImage: {},
      fileData: {},
      tabActive: 'audio',
      version_message: '',
      isDisconnectSocketSpeech: false,
    }
  },
  computed: {
    fileManagerTitle() {
      return this.$store.state.files.file_manager.title;
    },
    showFileManagerModal: {
      get() {
        // console.log('show_file_manager', this.$store.state.files.show_file_manager);
        return this.$store.state.files.show_file_manager;
      },
      set(val) {
        this.$store.dispatch('files/setState', { show_file_manager: val });
      },
    },
  },
  setup(props, context) {
    const { route, router } = useRouter();
    const dataUser = useJwt.getUserLocal();
    const user_id = ref(dataUser.id)
    const pseudonym_alias = (dataUser) ? dataUser.alias : '';
    const api_tags = `${process.env.VUE_APP_NEWS_API_URL}tags/search?search=:search`
    const state = reactive({
      tinyOptions: null,
      api_upload: apiUpload,
      api_download: apiDownload,
    })
    state.tinyOptions = computed(() => {
      if (store.state.app.settings) {
        if (store.state.app.settings.news !== undefined && store.state.app.settings.news.editor_toolbar !== undefined) {
          const icons = store.state.app.settings.news.editor_toolbar.map(({ icon }) => icon);
          defaultOptions.toolbar = icons.join(' ');
        }
        if (store.state.app.settings.app !== undefined && store.state.app.settings.app.logo_mask !== undefined) {
          defaultOptions.images_mask_logo = dynamicImageSettingSrcByDomain(store.state.app.settings.app.logo_mask);
          // defaultOptions.images_mask_logo = 'https://auth.tintucvov.vn:1236/upload/setting/e97f6caa278662da90be88a4e6299d5c.31052023.png';
        }
      }
      return defaultOptions
    });

    const loading = ref(true);
    const defaultItemData = {
      id: '',
      title: '',
      article_type_id: '',
      content_type: ['news'],
      category_id: '',
      main_cats: [],
      image: '',
      featured: false,
      hot: false,
      dalet: 1,
      author: [],
      note: '',
      category_type_id: [],
      attached_files: [],
      department_id: null,
      content_files: [],
      relate_data: [],
      tags: [],
      content: `<p>&nbsp;</p><p>&nbsp;</p><p class="text-align-right" style="text-align: right;"><strong><em>${pseudonym_alias}--Cộng tác viên--CTV Đài TNVN</em></strong></p>`,
      pseudonym: '',
      published_at: '',
      status: 1,
      is_timer: 0,
      internal: '',
    }

    const frmData = ref(JSON.parse(JSON.stringify(defaultItemData)))

    const resetItemData = () => {
      frmData.value = JSON.parse(JSON.stringify(defaultItemData))
    }

    const accessToken = getToken();
    const dataArticleType = ref([]);
    const dataContentType = ref([]);
    const files_content = ref([]);
    const dataAuthor = ref([]);
    const dataDepartment = ref([]);
    const workflowTransition = ref([]);
    const access_editing = ref('');
    const version_old = ref({});
    const autoSave = ref(false)
    const attached_files = ref([])
    const message_version = ref('');
    const all_cats = ref([]);
    const data_cats = ref([]);
    const opacity = ref('')
    const tags = ref([])
    const dataCategoryType = ref([])
    const allow_show_published = ref(false)
    const show_nhoxuly = ref(true);
    const custom_header = ref({
      Authorization: `Bearer ${accessToken}`,
    })
    const confirmMessage = _.debounce((data, message) => {
      if (message && data) {
        Vue.swal({
          title: '',
          text: message,
          showDenyButton: true,
          confirmButtonText: 'Tiếp tục chỉnh sửa',
          denyButtonText: 'Hủy bản nháp',
          allowEscapeKey: false,
          allowOutsideClick: false,
          allowEnterKey: false,
          customClass: {
            confirmButton: 'btn btn-success',
            denyButton: 'btn btn-danger ml-1',
          },
          buttonsStyling: false,
        }).then(result => {
          if (result.isConfirmed) {
            const json = JSON.parse(data.content);

            // for (const [key, value] of Object.entries(json)) {
            //   frmData.value[key] = value;
            // }
            Object.entries(json).forEach(entry => {
              const [key, value] = entry
              frmData.value[key] = value;
            })
            version_old.value = { ...frmData.value };
          } else if (result.isDenied) {
            store.dispatch('article/destroy', { ids: [data.id], type: 'draft' }).then(response => {
              if (response.data.code === 200) {
                frmData.value.message_version = '';
                frmData.value.version = {}
              }
            })
          }
        })
      }
    }, 1000)

    const article_id = route.value.params.id !== undefined ? route.value.params.id : 0;
    const fetchOne = (id) => {
      loading.value = true;
      store.dispatch('article/edit', { id: id || article_id })
        .then(response => {
          loading.value = false;

          if (response.status === 200) {
            const result = response.data;
            if (result.code === 200) {
              const fData = result.data;

              frmData.value = fData;
              version_old.value = { ...fData };
              files_content.value = result.data.content_files;
              attached_files.value = result.data.attached_files;
              dataAuthor.value = result.data.dataAuthor;
              all_cats.value = result.data.config.all_cats;
              data_cats.value = result.data.config.data_cats;
              dataArticleType.value = result.data.config.articleType;
              dataContentType.value = result.data.config.contentType
              workflowTransition.value = result.data.config.workflow_transition
              dataDepartment.value = result.data.config.department;
              dataCategoryType.value = result.data.config.categoryType
              allow_show_published.value = result.data.config.allow_show_published

              result.data.config.workflow_transition.forEach((itemVal) => {
                if (itemVal.target_state == 2) {
                  show_nhoxuly.value = false
                }
              })

              if (frmData.value.tags.length > 0) {
                tags.value = frmData.value.tags.map((val, index) => {
                  index++;
                  return { id: index, name: val }
                })
              }

              confirmMessage(result.data.config.version, result.data.config.version_message);
            } else {
              access_editing.value = response.data.message;
            }
          }
        })
    }
    fetchOne();

    const {
      refFormObserver,
      getValidationState,
      resetForm,
    } = formValidation(frmData)

    const autoDraft = setInterval(() => {
      if (version_old.value === undefined || version_old.value === null) return
      let flag = false;
      // for (const [key, value] of Object.entries(version_old.value)) {
      //   if (JSON.stringify(frmData.value[key]) !== JSON.stringify(value)) {
      //     flag = true;
      //     break;
      //   }
      // }
      Object.entries(version_old.value).forEach(entry => {
        const [key, value] = entry;
        // console.log(key, value);
        if (JSON.stringify(frmData.value[key]) !== JSON.stringify(value)) {
          flag = true;
        }
      });
      if (flag) {
        const content = JSON.stringify(frmData.value);
        const params = {
          article_id: frmData.value.id,
          content,
        }
        store.dispatch('article/draft', params).then(response => {
          const result = response.data;
          if (result.code == 200) {
            version_old.value = result.data;
            showToast(result.message, { variant: 'success' })
          }
        })
      }
    }, 30000);

    const config_date = ref({
      dateFormat: 'H:i, d-m-Y',
      wrap: true,
      enableTime: true,
      time_24hr: true,
      defaultHour: new Date().getHours(),
      defaultMinute: new Date().getMinutes(),
      locale: Vietnamese, // locale for this instance only
    });
    const { openFileManager, getNotifyArticle } = useArticle();

    watch(
      () => route.value.params.id,
      (newId, oldId) => {
        fetchOne(newId)
      },
    )

    return {
      ...toRefs(state),
      refFormObserver,
      getValidationState,
      resetForm,
      frmData,
      dataArticleType,
      dataContentType,
      files_content,
      dataAuthor,
      custom_header,
      dataDepartment,
      resetItemData,
      workflowTransition,
      access_editing,
      autoSave,
      message_version,
      all_cats,
      data_cats,
      loading,
      autoDraft,
      attached_files,
      config_date,
      article_id,
      opacity,
      api_tags,
      tags,
      dataCategoryType,
      openFileManager,
      getNotifyArticle,
      user_id,
      allow_show_published,
      socketSpeech: null,
      show_nhoxuly,
    }
  },
  beforeMount() {
    window.addEventListener('scroll', this.handleScroll)
  },
  beforeRouteLeave(to, from, next) {
    clearInterval(this.autoDraft);
    const article_id = from.params.id;
    if (!this.access_editing) {
      const params = { type: 'unlock', ids: { article_id } }
      store.dispatch('article/lock', params).then(response => { })
    }

    if (this.socketSpeech) {
      this.socketSpeech.disconnect();
    }

    next()
  },
  mounted() {
    window.onpopstate = function (event) {
      clearInterval(this.autoDraft);
    };
    this.$store.commit('verticalMenu/UPDATE_VERTICAL_MENU_COLLAPSED', true);

    this.initSocket();
  },
  methods: {
    logDalet(val) {
      // console.log('val', val)
    },
    handleScroll(e) {
      if (window.pageYOffset > 20) {
        this.topClass = 'top_class';
      } else {
        this.topClass = '';
      }
    },
    onPreview() {
      this.$bvModal.show('showPreview');
    },
    handlRemoveRelate(item) {
      const relateData = this.frmData.relate_data.filter((val) => val.id != item.id);
      this.frmData.relate_data = relateData;
    },
    handleRelate(data) {
      const itemActive = this.frmData.relate_data.filter((val) => val.id == data.id);
      if (itemActive.length > 0) {
        const relateData = this.frmData.relate_data.filter((val) => val.id != data.id);
        this.frmData.relate_data = relateData;
      } else {
        this.frmData.relate_data.push(data);
      }
    },
    getCategory(type = '') {
      store.dispatch('category/fetchAll', { type, style: 1 })
        .then(response => {
          const result = response.data
          if (result.code === 200) {
            if (result.data.length > 0) {
              this.data_cats = result.data;
              if (this.list_cats.length > 0) {
                result.data.forEach(item => {
                  if (this.list_cats.includes(item.code)) {
                    this.all_cats.push(item)
                  }
                });
              } else {
                this.all_cats = result.data;
              }
            }
          }
        })
    },
    onSearch(search, loading) {
      if (search.length) {
        loading(true);
        this.search(loading, search, this);
      }
    },
    search: _.debounce((loading, search, vm) => {
      axios.get(`users/search?keyword=${search}`)
        .then((response) => {
          const dataNews = vm.dataAuthor;
          if (response.data.data.length > 0) {
            response.data.data.map((item) => {
              if (!vm.frmData.author.includes(item.id)) {
                dataNews.push(item);
              }
            })
          }
          const sortedObjs = _.sortBy(dataNews, 'full_name');
          vm.dataAuthor = sortedObjs
          loading(false);
        })
    }, 1000),
    validationForm(status) {
      this.frmData.status = status;
      if (this.tags.length > 0) {
        this.frmData.tags = this.tags.map(tagItem => tagItem.name);
      }
      this.$refs.articleForm.validate()
        .then(success => {
          if (success) {
            if (this.frmData.status === 2 && !this.frmData.department_id) {
              showToast('Chưa chọn phòng nhờ xử lý.')
              this.$refs.articleForm.department_id.focus();
            } else {
              this.onSubmit();
            }
          } else {
            window.scrollTo({ top: 0, left: 0, behavior: 'smooth' });
          }
        })
    },
    onSubmit() {
      const article_id = this.frmData.id;
      this.loading = true;
      this.opacity = 'opacity2'
      const newContentFiles = [];

      if (this.frmData.content_files.length) {
        this.frmData.content_files.forEach(item => {
          const newitem = { ...item };
          delete newitem.file;
          delete newitem.headers;
          delete newitem.uploader;
          newContentFiles.push(newitem)
        });
      }
      this.frmData.content_files = newContentFiles;
      // console.log('onSubmit this.frmData: ', this.frmData);
      store.dispatch('article/update', { data: this.frmData, id: article_id })
        .then(response => {
          this.loading = false;
          this.opacity = '';
          if (response.data.code === 200) {
            const result = response.data.data;
            showToast(response.data.message, { variant: 'success' })

            if (result.url) {
              this.$router.push({ name: result.url });
            }
            this.getNotifyArticle()
          } else {

            if (Object.keys(response.data.errors).length > 0) {
              this.$refs.articleForm.setErrors(response.data.errors);
            } else {
              showToast(response.data.message);
            }
          }
        })
    },
    updateIcon(item) {
      if (item.type === 'image' || item.isImage) {
        if (!this.frmData.content_type.includes('photo')) {
          this.frmData.content_type.push('photo')
        }
      } else if (item.type === 'video' || item.isVideo) {
        if (!this.frmData.content_type.includes('video')) {
          this.frmData.content_type.push('video')
        }
      } else if (item.type === 'audio' || item.isAudio) {
        if (!this.frmData.content_type.includes('audio')) {
          this.frmData.content_type.push('audio')
        }
      }
    },
    UpdateContentEditor(item) {
      const data = item.response != undefined ? item.response : item;
      if (typeof data.name !== undefined) {
        const res = (item.response !== undefined) ? item.response.data : item;
        res.full_path = res.full_path || res.file_local;
        insertFileToEditor(res);
        this.updateIcon(res)
        // hide transcrible modal
        this.hideTranscribeModal();
      }
    },
    onUpdateAttachedFiles(attachedFiles) {
      // console.log('onUpdateAttachedFiles --> ', attachedFiles);
      this.frmData.attached_files = attachedFiles
      // console.log('onUpdateAttachedFiles --> this.frmData.attached_files', this.frmData.attached_files);
    },
    onUpdateContentFile(files) {
      console.log('onUpdateContentFile-->files', files);
      this.frmData.content_files = files;
      // console.log('this.frmData.content_files', this.frmData.content_files);
    },
    onDeleteFileContent(file) {
      // console.log('this.frmData.content_files:', this.frmData.content_files);
      // console.log('file:', file);
      if (this.frmData.content_files.length > 0) {
        const content_files = this.frmData.content_files.filter((item) => item.id != file.id)
        // this.$refs.upload.remove(file)
        this.frmData.content_files = content_files;
      }
    },
    onExit(id, status, created_by) {
      if (status == 1) {
        this.$router.push({ name: 'article-private' });
      } else {
        const params = { type: 'unlock', ids: { id } }
        store.dispatch('article/lock', params).then(response => {
          const result = response.data;
          if (result.code == 200) {
            if (status == 1) {
              this.$router.push({ name: 'article-private' });
            } else if (status == 2) {
              if (created_by == this.user_id) {
                this.$router.push({ name: 'article-private' });
              } else {
                this.$router.push({ name: 'article-draft' });
              }
            } else if (status == 3) {
              this.$router.push({ name: 'article-approved' });
            } else if (status == 4) {
              this.$router.push({ name: 'article-corrected' });
            } else if (status == 5) {
              this.$router.push({ name: 'article-published' });
            } else if (status == 6) {
              this.$router.push({ name: 'article-archived' });
            }
          }
        })
      }
    },

    onDestroy(id, status) {
      this.$swal({
        title: '',
        text: 'Bạn có chắc chắn muốn xóa bài viết này không?',
        showCancelButton: true,
        confirmButtonText: 'Có',
        cancelButtonText: 'Không',
        customClass: {
          confirmButton: 'btn btn-success',
          cancelButton: 'btn btn-danger ml-1',
        },
        buttonsStyling: false,
      }).then(result => {
        if (result.isConfirmed) {
          this.loading = true

          store.dispatch('article/destroy', { ids: [id], type: '' }).then(response => {
            const result = response.data;
            if (result.code == 200) {
              this.loading = false
              if (status == 1) {
                this.$router.push({ name: 'article-private' });
              } else if (status == 2) {
                this.$router.push({ name: 'article-draft' });
              } else if (status == 3) {
                this.$router.push({ name: 'article-approved' });
              } else if (status == 4) {
                this.$router.push({ name: 'article-corrected' });
              } else if (status == 5) {
                this.$router.push({ name: 'article-published' });
              } else if (status == 6) {
                this.$router.push({ name: 'article-archived' });
              }
              showToast(result.message, { variant: 'success' })
            } else {
              showToast(result.message);
            }
          })
        }
      })
    },
    onPreviewFile(item) {
      this.dataImage = item
      // console.log('dataImage', this.dataImage);
      this.$bvModal.show('filePreview');
    },
    downloadFile(item) {
      if (item) {
        window.location.href = `${apiDownload}?file=${item.full_path}`;
      }
    },
    handleSpeechToText(content) {
      // console.log('hanld text to speech', content)
      // console.log('tinymce', tinymce)
      tinymce.activeEditor.insertContent(content);
    },
    showTranscribeModal(item) {
      this.fileData = item;
      this.$bvModal.show('fileTranscribeModal');
    },
    hideTranscribeModal() {
      this.$bvModal.hide('fileTranscribeModal');
    },
    focusAudioPlayer() {
      // console.log('this.$refs.refFileTranscribeText', this.$refs.refFileTranscribeText);
      // this.$refs.refFileTranscribeText.$refs.refTinymceSpeech.editor.focus()
      // console.log('this.$refs.refFileTranscribeModal', this.$refs.refFileTranscribeModal);
      // this.$refs.refFileTranscribeText.$refs.refAudioWrapper.focus()
      // this.$refs.refFileTranscribeModal.$el.style.zIndex = 1020
    },
    updateTranscribeStatus(data) {
      console.log('edit article updateTranscribeStatus', data);
      this.fileData.transcribe = data.transcribe
      if (this.frmData.content_files) {
        this.frmData.content_files.find((o, idx) => {
          if (o.id === data.id) {
            o.transcribe = data.transcribe
            this.$set(this.frmData.content_files, idx, o)
          }
        });
      }
    },
    closeSocketSpeech() {
      this.$store.dispatch('speech/setState', { isDisconnectSocket: (new Date()).getTime() })
    },
    initSocket() {
      // const that = this;
      const socketUrl = process.env.VUE_APP_SPEECH_SOCKET || 'http://localhost:3006';
      const socketPath = process.env.VUE_APP_SPEECH_SOCKET_PATH || '/socket.io/';
      const socket = io(socketUrl, {
        path: socketPath,
        transports: ['websocket'],
      });
      // console.log('socketUrl', socketUrl);
      // console.log('socketPath', socketPath);
      this.socketSpeech = socket;

      socket.on('connect', () => {
        console.log('socket speech on connect');
        this.socketId = socket.id;
      });

      socket.on('file-transcribed', (data) => {
        //console.log('socket on file-transcribed data', data);
        //console.log('this.frmData.content_files', this.frmData.content_files);
        if (this.fileData.id === data.id) {
          this.fileData.transcribe = data.transcribe
        }
        if (this.frmData.content_files) {
          this.frmData.content_files.find((o, idx) => {
            if (o.id === data.id) {
              showToast(`Rải băng ${o.filename_original} thành công`, { variant: 'success' });
              o.transcribe = data.transcribe
              this.$set(this.frmData.content_files, idx, o)
            }
          });
        }
      });
      socket.on('test-send-message', () => {
        showToast('test send message');
      });
      socket.on('disconnect', () => {
        console.log('socket speech on disconnect');
      });
    },
  },

}
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
@import '@core/scss/vue/libs/vue-flatpicker.scss';
</style>
